import LegalbirdIoModal from "../Modal/LegalbirdIoModal";
import { Conversation } from "../../types/Messaging/Conversation";
import { FormContainer, RadioButtonGroup, useForm } from "react-hook-form-mui";
import { Roles } from "../../types/BackofficeUser";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import { userHasOneOfTheseRoles } from "../../services/backofficeUserService";
import ButtonLoading from "../Button/ButtonLoading";
import { useState } from "react";
import { Channel } from "../../types/Messaging/Channel";
import { useSnackbar } from "notistack";
import { apiGet, apiPatch } from "../../services/Api/apiCall";

type ChangeMessageVisibilityModalProps = {
  open: boolean;
  handleClose: () => void;
  conversation: Conversation;
  refetchConversations: Function;
};

export default function ChangeMessageVisibilityModal({
  open,
  handleClose,
  conversation,
  refetchConversations,
}: ChangeMessageVisibilityModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const currentUser = useCurrentUser();
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    channelType: conversation.channel.type,
  };

  const formContext = useForm({
    mode: "onBlur",
    defaultValues: defaultValues,
  });

  const onSubmit = async (values: typeof defaultValues) => {
    setIsLoading(true);
    let messageText = "Die Sichtbarkeit der Konversation wurde erfolgreich geändert";
    let snackbarVariant: "custom" | "error" = "custom";

    try {
      const allChannels = await apiGet("/channels", null, {
        case: conversation.channel.caseId,
      });
      const newChannel = allChannels["hydra:member"].find((channel: Channel) => channel.type === values.channelType);
      await apiPatch("/conversations", conversation.id, {
        channel: `/channels/${newChannel.id}`,
      });

      refetchConversations();
    } catch (e) {
      messageText = "Die Sichtbarkeit der Konversation konnte nicht geändert werden";
      snackbarVariant = "error";
    } finally {
      setIsLoading(false);
      handleClose();
    }

    enqueueSnackbar(messageText, {
      variant: snackbarVariant,
      isNonInteractive: true,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center",
      },
    });
  };

  return (
    <LegalbirdIoModal
      title={"Sichtbarkeit einstellen"}
      open={open}
      handleClose={handleClose}
      submitButton={
        <FormContainer formContext={formContext} onSuccess={onSubmit}>
          <ButtonLoading variant={"contained"} type={"submit"} isLoading={isLoading}>
            Sichtbarkeit ändern
          </ButtonLoading>
        </FormContainer>
      }
    >
      <FormContainer formContext={formContext} onSuccess={onSubmit}>
        <RadioButtonGroup
          name={"channelType"}
          label={"Für wen soll die Konversation sichtbar sein?"}
          options={[
            { id: "all", label: "Alle" },
            { id: "internalPlusCustomer", label: "Intern + Mandantschaft" },
            {
              id: "internalOnly",
              label: "Nur Intern",
              disabled: !userHasOneOfTheseRoles(currentUser, [Roles.admin, Roles.leadAccountmanager, Roles.leadLawyer]),
            },
          ]}
        />
      </FormContainer>
    </LegalbirdIoModal>
  );
}
